import forDevice from '../../hoc/for-device';
import { fetchPostEditorSSRData } from '../../services/post-editor';
import PostEditorPageLoader from './post-editor-page-loader';
import PostEditorModalLoader from './post-editor-modal-loader';

// Post editor state is handled in post publish middleware.
// For desktop will fetch categories, post and display post editor.
// For mobile will fetch categories, post and pass them to post editor modal.
const PostEditorPageOrModal = forDevice(PostEditorModalLoader, PostEditorPageLoader);

PostEditorPageOrModal.fetchData = fetchPostEditorSSRData;

export default PostEditorPageOrModal;
